import { render, staticRenderFns } from "./activity.vue?vue&type=template&id=c2a9d030&"
import script from "./activity.vue?vue&type=script&lang=ts&"
export * from "./activity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports